import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import { updateLLMCall } from "../graphql/mutations";
import {
  UpdateLLMCallMutation
} from "../API";

export async function updateLLMCallQuality(
  id: string,
  quality: number
): Promise<GraphQLResult<UpdateLLMCallMutation>> {
  return API.graphql(
    graphqlOperation(updateLLMCall, {
      input: {
        id: id,
        quality: quality,
      },
    })
  ) as Promise<GraphQLResult<UpdateLLMCallMutation>>;
}
